import {
  CREATE_NOTIFICATION,
  RETRIEVE_ADMIN_NOTIFICATION_LIST,
  RETRIEVE_ADMIN_NOTIFICATION_DETAIL,
  RETRIEVE_BUS_NOTIFICATION_LIST,
  RETRIEVE_BUS_NOTIFICATION_DETAIL,
  RETRIEVE_PARENT_UPDATE_HISTORY_LIST,
  RETRIEVE_PARENT_UPDATE_HISTORY_DETAIL,
  RETRIEVE_PARENT_NOTIFICATION_LIST,
  RETRIEVE_PARENT_NOTIFICATION_DETAIL,
  RETRIEVE_CANCEL_LIST,
  RETRIEVE_CANCEL_DETAIL,
  RETRIEVE_ADMIN_NOTIFICATION_PARENT_LIST,
  RETRIEVE_AUTHORIZED_PERSON_NOTIFICATION_LIST,
  RETRIEVE_AUTHORIZED_PERSON_NOTIFICATION_DETAIL
} from '@/api'

export default {
  createNotification({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_info) {
        // commit('addClassToList', {classList: response.data.data.class_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_NOTIFICATION({data: payload.data}, successCallback, errorCallback)
  },

  retrieveAdminNotificationList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.notification_list.length) {
        commit('retrieveAdminNotificationList', {notificationList: response.data.data.notification_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_ADMIN_NOTIFICATION_LIST({}, successCallback, errorCallback)
  },

  retrieveAdminNotificationDetail({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_ADMIN_NOTIFICATION_DETAIL({id: payload.id}, successCallback, errorCallback)
  },

  retrieveBusNotificationList(state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_BUS_NOTIFICATION_LIST(payload, successCallback, errorCallback)
  },

  retrieveBusNotificationDetail({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_BUS_NOTIFICATION_DETAIL({id: payload.id}, successCallback, errorCallback)
  },

  retrieveParentUpdateHistoryList(state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_PARENT_UPDATE_HISTORY_LIST(payload, successCallback, errorCallback)
  },

  retrieveParentUpdateHistoryDetail({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_PARENT_UPDATE_HISTORY_DETAIL({id: payload.id}, successCallback, errorCallback)
  },

  retrieveParentNotificationList(state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_PARENT_NOTIFICATION_LIST(payload, successCallback, errorCallback)
  },

  retrieveParentNotificationDetail({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_PARENT_NOTIFICATION_DETAIL({id: payload.id}, successCallback, errorCallback)
  },

  retrieveCancelList({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_CANCEL_LIST(payload, successCallback, errorCallback)
  },

  retrieveCancelDetail({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    let id = payload.id || null

    RETRIEVE_CANCEL_DETAIL({ id }, successCallback, errorCallback)
  },

  retrieveParentList(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_ADMIN_NOTIFICATION_PARENT_LIST(successCallback, errorCallback)
  },

  retrieveAuthorizedPersonNotificationList(state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_AUTHORIZED_PERSON_NOTIFICATION_LIST(payload, successCallback, errorCallback)
  },

  retrieveAuthorizedPersonNotificationDetail(state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_AUTHORIZED_PERSON_NOTIFICATION_DETAIL(payload, successCallback, errorCallback)
  },
};
